import { Injectable } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { OnboardingLeaderboard } from './onboarding-leaderboard.model'

@Injectable({ providedIn: 'root' })
export class OnboardingLeaderboardStore extends EntitySignalStore<OnboardingLeaderboard> {
  constructor() {
    super({
      name: 'onboarding-leaderboard',
      entityConstructor: entry => new OnboardingLeaderboard(entry),
      persist: false
    })
  }
}
